import { BackButton } from '../back-button/back-button';
import { ContentContainerMax } from '../../layout/container';
import React, { FC } from 'react';
import {
  FontPrimarySemiBold,
  Icon,
  mediaQueries,
  spacingBottom,
  spacingRight,
} from '@digando/react-component-library';
import styled from '@emotion/styled';
import { spacingTop, spacingLeft } from '@digando/react-component-library';
import { ProductType } from '../../@types/codegen/graphql';
import { ProductBreadcrumb } from '../product/product-breadcrumb';
import { useTranslation } from 'next-i18next';
import { isFeatureFlagEnabled } from '../../lib/environment';

interface IProductHeaderProps {
  category: ProductType['mainCategory'];
  productTitle: string;
}

const ProductHeaderComponent: FC<IProductHeaderProps> = ({ category, productTitle }) => {
  const [t] = useTranslation('common');

  return (
    <ContentContainerMax>
      <ProductHeaderInner>
        <div>
          <ProductBreadcrumb category={category} productTitle={productTitle} />
          <BackButton label={t('common:back-to-search-label')} />
        </div>
        {isFeatureFlagEnabled('isSupportEnabled') && (
          <SupportWrapper>
            <Icon icon="phone" size={'40px'} />
            <div>
              <PhoneWrapper>
                {t('support-hotline')}<a href={'tel:' + t('support-phone')}>{t('support-phone')}</a>
              </PhoneWrapper>
            </div>
          </SupportWrapper>
        )}
      </ProductHeaderInner>
    </ContentContainerMax>
  );
};

const ProductHeaderInner = styled.div`
  grid-column: auto / span 12;
  ${spacingTop(3)};
  ${spacingBottom(4)};
  display: flex;
  justify-content: space-between;
`;

const SupportWrapper = styled.div`
  display: none;

  @media ${mediaQueries.laptop} {
    display: flex;
    align-items: center;

    span {
      ${spacingRight(2)};
    }

    a {
      color: var(--black);
      ${spacingLeft(0.5)};
    }
  }
`;

const PhoneWrapper = styled.div`
  ${FontPrimarySemiBold};
  font-size: var(--font-size-text);
  display: flex;
  align-items: center;
  line-height: 22px;
`;

export const ProductHeader = React.memo(ProductHeaderComponent, (prevProps, nextProps) => {
  return prevProps.productTitle === nextProps.productTitle && prevProps?.category?.id === nextProps?.category?.id;
});
